import { FC } from "react";

import { Issue } from "@protos/issues/v1/issues";

import { FindingInfoIconList } from "../FindingInfoIconList";

export interface SecretsFindingInfoIconListProps {
  finding: Issue;
}

export const SecretsFindingInfoIconList: FC<
  SecretsFindingInfoIconListProps
> = ({ finding }) => {
  return <FindingInfoIconList finding={finding} />;
};
